import React from 'react';
import AuthService from './authService.js';
import TpPlatformInvoiceItem from '../Domain/ThirdParty/TpPlatformInvoice/TpPlatformInvoiceItem';
import TpPlatformInvoiceLineItem from '../Domain/ThirdParty/TpPlatformInvoice/TpPlatformInvoiceLineItem';
import TpPlatformInvoiceSummaryItem from '../Domain/ThirdParty/TpPlatformInvoice/TpPlatformInvoiceSummaryItem';
import TpPlatformInvoiceBravoJobItem from '../Domain/ThirdParty/TpPlatformInvoice/TpPlatformInvoiceBravoJobItem';
import dateTimeHelper from '../Helpers/datetimeHelper';

export default class TpPlatformInvoiceService extends React.Component {
  static GetAllItemsBySearching(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false) {
    // This service hand-builds its payload and calls raw JSON.stringify — it does NOT use the
    // SearchParams wrapper, so nothing else converts dates. A raw JS Date serializes to an ISO
    // datetime that the backend's DateOnly.TryParse rejects SILENTLY: the filter just never
    // applies. toYYYYsMMsDD is idempotent, so re-converting a converted value is harmless.
    searchItem.InvoiceDateFrom = dateTimeHelper.toYYYYsMMsDD(searchItem.InvoiceDateFrom);
    searchItem.InvoiceDateTo = dateTimeHelper.toYYYYsMMsDD(searchItem.InvoiceDateTo);
    const searchParams = {
      Command: '',
      OrderBy: orderById,
      OrderDirection: orderDir,
      PageNumber: pageNumber,
      NumberOfElementsOnAPage: numberOfElements,
      SearchItem: searchItem,
    };
    const url = `/api/TpPlatformInvoice/GetInvoices/?searchParams=${JSON.stringify(
      searchParams
    )}&clearCache=${clearCache}`;
    return AuthService.getInstance().CallBackendFunction(url);
  }

  static GetItemsBySearching(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false) {
    const searchParams = {
      Command: '',
      OrderBy: orderById,
      OrderDirection: orderDir,
      PageNumber: pageNumber,
      NumberOfElementsOnAPage: numberOfElements,
      SearchItem: searchItem,
    };
    const url = `/api/TpPlatformInvoice/GetInvoiceItems/?searchParams=${JSON.stringify(
      searchParams
    )}&clearCache=${clearCache}`;
    return AuthService.getInstance().CallBackendFunction(url);
  }

  static ConvertDBItems(items) {
    const convertedItems = [];
    if (items !== null) {
      items.forEach((item) => convertedItems.push(new TpPlatformInvoiceItem(item)));
    }
    return convertedItems;
  }

  static ConvertDBLineItems(items) {
    const convertedItems = [];
    if (items !== null) {
      items.forEach((item) => convertedItems.push(new TpPlatformInvoiceLineItem(item)));
    }
    return convertedItems;
  }

  static GetCostSummariesBySearching(
    orderById,
    orderDir,
    pageNumber,
    numberOfElements,
    searchItem,
    clearCache = false
  ) {
    const searchParams = {
      Command: '',
      OrderBy: orderById,
      OrderDirection: orderDir,
      PageNumber: pageNumber,
      NumberOfElementsOnAPage: numberOfElements,
      SearchItem: searchItem,
    };
    const url = `/api/TpPlatformInvoice/GetInvoiceCostSummaries/?searchParams=${JSON.stringify(
      searchParams
    )}&clearCache=${clearCache}`;
    return AuthService.getInstance().CallBackendFunction(url);
  }

  static ConvertDBCostSummaryItems(items) {
    const convertedItems = [];
    if (items !== null) {
      items.forEach((item) => convertedItems.push(new TpPlatformInvoiceSummaryItem(item)));
    }
    return convertedItems;
  }

  static GetBravoJobsBySearching(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false) {
    // Raw JSON.stringify, no SearchParams wrapper — an unconverted Date is silently rejected by
    // the backend parser and the filter never applies. toYYYYsMMsDD is idempotent.
    searchItem.DateAssignedFrom = dateTimeHelper.toYYYYsMMsDD(searchItem.DateAssignedFrom);
    searchItem.DateAssignedTo = dateTimeHelper.toYYYYsMMsDD(searchItem.DateAssignedTo);
    const searchParams = {
      Command: '',
      OrderBy: orderById,
      OrderDirection: orderDir,
      PageNumber: pageNumber,
      NumberOfElementsOnAPage: numberOfElements,
      SearchItem: searchItem,
    };
    const url = `/api/TpPlatformInvoice/GetBravoJobs/?searchParams=${JSON.stringify(
      searchParams
    )}&clearCache=${clearCache}`;
    return AuthService.getInstance().CallBackendFunction(url);
  }

  static ConvertDBBravoJobItems(items) {
    const convertedItems = [];
    if (items !== null) {
      items.forEach((item) => convertedItems.push(new TpPlatformInvoiceBravoJobItem(item)));
    }
    return convertedItems;
  }

  static ExportBravoJobsToExcel(searchItem) {
    // The export shares the popup's search item, so it needs the same conversion — otherwise the
    // spreadsheet would silently ignore a date range the grid honoured.
    searchItem.DateAssignedFrom = dateTimeHelper.toYYYYsMMsDD(searchItem.DateAssignedFrom);
    searchItem.DateAssignedTo = dateTimeHelper.toYYYYsMMsDD(searchItem.DateAssignedTo);
    const url = `/api/TpPlatformInvoice/ExportBravoJobsToExcel?searchItem=${JSON.stringify(searchItem)}`;
    return AuthService.getInstance().CallBackendFunctionPost(url);
  }

  static SetBillingPeriodOverride(edited) {
    const url = 'api/TpPlatformInvoice/SetBillingPeriodOverride/';
    return AuthService.getInstance().CallBackendFunctionPut(url, JSON.stringify(edited));
  }
}
